<template>
  <div id="contenedor-contrato-editar-inventario">
    <v-form
      v-model="formularioValido"
      ref="formEditarContratoInventario">
      <v-card>
        <v-card-title class="secondary--text">
          Editar inventario
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
              <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-date-picker
              cols="12"
              md="6"
              v-model="inventario.fecha"
              label="Fecha">
            </custom-date-picker>
          <!-- listado de insumos -->
          <v-list
            subheader
            dense>
            <template
              v-for="agrupador in listadoDeInsumosConAgrupador">
              <template>
                <v-subheader
                  :key="agrupador.agrupador">
                  {{ agrupador.agrupador }}
                </v-subheader>
                <v-divider
                  :key="`divider-${agrupador.agrupador}`">
                </v-divider>
                <template
                  v-for="insumo in agrupador.insumos">
                  <template>
                    <v-list-item
                      :key="insumo.id">
                      <v-list-item-title>
                        {{ insumo.insumo.descripcion }}
                      </v-list-item-title>
                      <v-list-item-action
                        style="width: 200px;">
                        <v-row
                          dense
                          align="center"
                          justify="space-around">
                          <v-col
                            cols="auto">
                            <v-btn
                              icon
                              @click="reducirInsumo(insumo)">
                              <v-icon>
                                mdi-minus
                              </v-icon>
                            </v-btn>
                          </v-col>
                          <v-col
                            cols="auto">
                            <v-chip
                              color="info"
                              class="text-subtitle-1">
                              {{ insumo.nuevaCantidad }}
                            </v-chip>
                          </v-col>
                          <v-col
                            cols="auto">
                            <v-btn
                              icon
                              @click="aumentarInsumo(insumo)">
                              <v-icon>
                                mdi-plus
                              </v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-list-item-action>
                    </v-list-item>
                  </template>
                </template>
              </template>
            </template>
          </v-list>
        </v-card-text>
        <v-card-actions
          v-if="mostrarAcciones">
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarContratoInventario"
            :disabled="!formularioValido || enviandoFormulario || inventario.insumos.length < 1"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixContratoInventarios from './mixContratoInventarios';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ContratoEditarInventario',
  mixins: [mixContratoInventarios],
  props: {
    idContrato: {
      type: String,
      requided: true,
    },
    mostrarAcciones: {
      type: Boolean,
      requided: false,
      default: true,
    },
    inventarioEditar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomDatePicker,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      listadoInsumosEditar: [],
      insumos: [],
      inventario: {
        fecha: this.inventarioEditar.fecha,
        insumos: [],
      },
    };
  },
  mounted() {
    this.setListadoInsumosEditar();
  },
  methods: {
    setListadoInsumosEditar() {
      this.listadoInsumosEditar = this.getInsumos;
    },
    aumentarInsumo(insumo) {
      const nuevoInsumo = insumo;
      nuevoInsumo.nuevaCantidad += 1;
    },
    reducirInsumo(insumo) {
      const nuevoInsumo = insumo;
      if (nuevoInsumo.nuevaCantidad <= 1) return;
      nuevoInsumo.nuevaCantidad -= 1;
    },
    limpiarFormulario() {
      this.$refs.formEditarContratoInventario.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
  computed: {
    getInsumos() {
      return this.inventarioEditar.insumos.map((insumo) => ({
        ...insumo,
        nuevaCantidad: insumo.cantidad,
      }));
    },
    listadoDeInsumosConAgrupador() {
      return [
        {
          agrupador: 'Personal',
          insumos: this.getInsumos
            .filter(({ insumo }) => insumo.tipo === 1)
            .sort((a, b) => a.insumo.orden - b.insumo.orden),
        },
        {
          agrupador: 'Maquinaria',
          insumos: this.getInsumos
            .filter(({ insumo }) => insumo.tipo === 2)
            .sort((a, b) => a.insumo.orden - b.insumo.orden),
        },
        {
          agrupador: 'Equipo',
          insumos: this.getInsumos
            .filter(({ insumo }) => insumo.tipo === 3)
            .sort((a, b) => a.insumo.orden - b.insumo.orden),
        },
      ];
    },
  },
  watch: {
    listadoInsumosEditar: {
      handler(listado) {
        const listadoInsumosReportados = listado
          .filter(({ nuevaCantidad }) => nuevaCantidad > 0);

        this.inventario.insumos = listadoInsumosReportados
          .map(({ idInsumo, nuevaCantidad }) => ({
            idInsumo,
            cantidad: nuevaCantidad,
          }));
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">

</style>
